/** @return {boolean} */
export const selectWeatherLoading = state => state.weather.get('loading')

/** @return {boolean} */
export const selectWeatherFailedToLoad = state => state.weather.get('failedToLoad')

/** @return {number | null} */
export const selectCurrentLocationId = state => parseInt(state.weather.get('currentLocationId'))

/** @return {string | null} */
export const selectCurrentLocationName = state => state.weather.get('currentLocationName')

/** @return {Immutable.List} */
export const selectCurrentLocationData = state => state.weather.get('currentLocationData')
